import cn from 'classnames';

import Heading from 'components/common/Heading';
import Subheading from 'components/common/Subheading';
import { HOME_CHEF } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';
import useFunnelMealPlan from 'hooks/useFunnelMealPlan';
import threeLinesImage from 'images/signUpFunnel/three-orange-lines.png';

import { mealCardHeading } from './mealCardData';
import MealCardSlider from './MealCardSlider';

const MenuGallery = () => {
  const mealPlanSlug = useFunnelMealPlan();
  const isHomeChef = useBrand(HOME_CHEF);

  return (
    <section
      className={cn('mt-4 bg-white-100 bp1:-mb-6 bp2:mt-16', {
        'bp1:bg-cream-100': isHomeChef,
        'pb-12': !isHomeChef,
      })}
    >
      <Heading
        className={cn('px-2 pt-8 text-center bp2:px-0 bp2:pt-10', {
          'text-green-100': isHomeChef,
          'text-tempo-black-100': !isHomeChef,
        })}
        brandStylesOverrides={cn({ h4: !isHomeChef })}
      >
        {mealCardHeading[mealPlanSlug]}
      </Heading>
      <Subheading
        brandStylesOverrides="text"
        className="text-secondary px-2 py-6 text-center bp2:px-0"
      >
        Our menus rotate weekly. Get a sneak peek to see what we're cooking up!
      </Subheading>
      <div
        className="bg-center bg-repeat-x"
        style={isHomeChef ? { backgroundImage: `url(${threeLinesImage})` } : {}}
      >
        <MealCardSlider />
      </div>
    </section>
  );
};

export default MenuGallery;
